const TodoId = {
  // General Todos
  WAREHOUSE: 1,
  PICKUP: 2,
  RATE_SHOPPING: 3,
  CONNECT: 4,
  NEGOTIATED_CARRIER: 5,
  INTERNATIONAL: 6,
  LABEL_LAYOUT: 7,
  BRANDED_TRACKING: 8,
  PACKAGE_SIZES: 9,
  PACKING_SLIPS: 10,
  FULFILLMENT: 11,
  INVENTORY_SYNC: 12,
  BUNDLES: 13,
  BRANDED_RETURNS: 14,
  RETURNS_URL: 15,
  RETURNS_HELP: 16,
  AUTO_ROUTING: 17,
  API: 18,
  REORDERING: 19,
  SHOPIFY_RETURNS: 20,
  GET_STARTED_WEBINAR: 21,
  ACCOUNT_OPTIMIZATION_WEBINAR: 22,
  DEMO_ORDER: 23,
  UPLOAD_PRODUCTS: 25,
  ACCOUNT_USERS: 26,
  LOT_TRACKING: 27,
  SHIPSTATION_INVENTORY: 28,
  IMPORT_PRODUCTS: 29,
  SETUP_RETURNS: 30,
  AUTOMATION_MORE_SETUP: 31,
  SETUP_INSURANCE: 32,
  PHONE_NUMBER_CAPTURE: 33,

  // Billing Plan Migration Todos
  BILLING_MIGRATION_TRY_PREMIUM: 34,
  BILLING_MIGRATION_RATE_SHOPPING: 36,
  BILLING_MIGRATION_INVENTORY_SYNC: 37,
  BILLING_MIGRATION_PICKING: 38,
  BILLING_MIGRATION_SELF_SERVICE_RETURNS: 39,
  BILLING_MIGRATION_SHIPPING_INSIGHTS: 40,
  BILLING_MIGRATION_PURCHASE_ORDERS: 41,
  BILLING_MIGRATION_STANDARD_WEBINAR: 44,
  BILLING_MIGRATION_PREMIUM_WEBINAR: 45,

  // General Todos (continued)
  PRODUCT_PRESET_GROUPS: 42,
  AUTOMATION_PLAYBOOK: 43,

  // Free Plan Todos
  FREEMIUM_CONNECT_STORE: 100,
  FREEMIUM_ADD_SHIP_FROM_ADDRESS: 101,
  FREEMIUM_ADD_PAYMENT_METHOD: 102,
  FREEMIUM_CONNECT: 103,
  FREEMIUM_SHIPSTATION_101: 104,
  FREEMIUM_RATE_SHOPPING: 105,
  FREEMIUM_LABEL_LAYOUT: 106,
  FREEMIUM_CREATE_RETURN_LABEL: 107,
  FREEMIUM_IMPORT_PRODUCTS: 108,
  FREEMIUM_SETUP_RETURNS: 109,
};

const STRING_TO_ENUM_MAPPING = {
  // Current lowercase underscore format
  warehouse: TodoId.WAREHOUSE,
  pickup: TodoId.PICKUP,
  rate_shopping: TodoId.RATE_SHOPPING,
  connect: TodoId.CONNECT,
  negotiated_carrier: TodoId.NEGOTIATED_CARRIER,
  international: TodoId.INTERNATIONAL,
  label_layout: TodoId.LABEL_LAYOUT,
  branded_tracking: TodoId.BRANDED_TRACKING,
  package_sizes: TodoId.PACKAGE_SIZES,
  packing_slips: TodoId.PACKING_SLIPS,
  fulfillment: TodoId.FULFILLMENT,
  inventory_sync: TodoId.INVENTORY_SYNC,
  bundles: TodoId.BUNDLES,
  branded_returns: TodoId.BRANDED_RETURNS,
  returns_url: TodoId.RETURNS_URL,
  returns_help: TodoId.RETURNS_HELP,
  auto_routing: TodoId.AUTO_ROUTING,
  api: TodoId.API,
  shipstation_inventory: TodoId.SHIPSTATION_INVENTORY,
  shopifyReturns: TodoId.SHOPIFY_RETURNS,
  automation_more_setup: TodoId.AUTOMATION_MORE_SETUP,
  shopify_returns: TodoId.SHOPIFY_RETURNS,
  get_started_webinar: TodoId.GET_STARTED_WEBINAR,
  account_optimization_webinar: TodoId.ACCOUNT_OPTIMIZATION_WEBINAR,
  demo_order: TodoId.DEMO_ORDER,
  upload_products: TodoId.UPLOAD_PRODUCTS,
  account_users: TodoId.ACCOUNT_USERS,
  lot_tracking: TodoId.LOT_TRACKING,
  reordering: TodoId.REORDERING,
  import_products: TodoId.IMPORT_PRODUCTS,
  setup_returns: TodoId.SETUP_RETURNS,
  setup_insurance: TodoId.SETUP_INSURANCE,
  product_preset_groups: TodoId.PRODUCT_PRESET_GROUPS,
  automation_playbook: TodoId.AUTOMATION_PLAYBOOK,
  billing_migration_try_premium: TodoId.BILLING_MIGRATION_TRY_PREMIUM,
  billing_migration_rate_shopping: TodoId.BILLING_MIGRATION_RATE_SHOPPING,
  billing_migration_inventory_sync: TodoId.BILLING_MIGRATION_INVENTORY_SYNC,
  billing_migration_picking: TodoId.BILLING_MIGRATION_PICKING,
  billing_migration_self_service_returns: TodoId.BILLING_MIGRATION_SELF_SERVICE_RETURNS,
  billing_migration_shipping_insights: TodoId.BILLING_MIGRATION_SHIPPING_INSIGHTS,
  billing_migration_purchase_orders: TodoId.BILLING_MIGRATION_PURCHASE_ORDERS,
  billing_migration_standard_webinar: TodoId.BILLING_MIGRATION_STANDARD_WEBINAR,
  billing_migration_premium_webinar: TodoId.BILLING_MIGRATION_PREMIUM_WEBINAR,
  freemium_connect_store: TodoId.FREEMIUM_CONNECT_STORE,
  freemium_add_ship_from_address: TodoId.FREEMIUM_ADD_SHIP_FROM_ADDRESS,
  freemium_add_payment_method: TodoId.FREEMIUM_ADD_PAYMENT_METHOD,
  freemium_connect: TodoId.FREEMIUM_CONNECT,
  freemium_shipstation_101: TodoId.FREEMIUM_SHIPSTATION_101,
  freemium_rate_shopping: TodoId.FREEMIUM_RATE_SHOPPING,
  freemium_label_layout: TodoId.FREEMIUM_LABEL_LAYOUT,
  freemium_create_return_label: TodoId.FREEMIUM_CREATE_RETURN_LABEL,
  freemium_import_products: TodoId.FREEMIUM_IMPORT_PRODUCTS,
  freemium_setup_returns: TodoId.FREEMIUM_SETUP_RETURNS,

  // Legacy uppercase format for backwards compatibility
  WAREHOUSE: TodoId.WAREHOUSE,
  PICKUP: TodoId.PICKUP,
  RATE_SHOPPING: TodoId.RATE_SHOPPING,
  CONNECT: TodoId.CONNECT,
  NEGOTIATED_CARRIER: TodoId.NEGOTIATED_CARRIER,
  INTERNATIONAL: TodoId.INTERNATIONAL,
  LABEL_LAYOUT: TodoId.LABEL_LAYOUT,
  BRANDED_TRACKING: TodoId.BRANDED_TRACKING,
  PACKAGE_SIZES: TodoId.PACKAGE_SIZES,
  PACKING_SLIPS: TodoId.PACKING_SLIPS,
  FULFILLMENT: TodoId.FULFILLMENT,
  INVENTORY_SYNC: TodoId.INVENTORY_SYNC,
  BUNDLES: TodoId.BUNDLES,
  BRANDED_RETURNS: TodoId.BRANDED_RETURNS,
  RETURNS_URL: TodoId.RETURNS_URL,
  RETURNS_HELP: TodoId.RETURNS_HELP,
  AUTO_ROUTING: TodoId.AUTO_ROUTING,
  API: TodoId.API,
  SHIPSTATION_INVENTORY: TodoId.SHIPSTATION_INVENTORY,
  SHOPIFY_RETURNS: TodoId.SHOPIFY_RETURNS,
  GET_STARTED_WEBINAR: TodoId.GET_STARTED_WEBINAR,
  ACCOUNT_OPTIMIZATION_WEBINAR: TodoId.ACCOUNT_OPTIMIZATION_WEBINAR,
  DEMO_ORDER: TodoId.DEMO_ORDER,
  UPLOAD_PRODUCTS: TodoId.UPLOAD_PRODUCTS,
  ACCOUNT_USERS: TodoId.ACCOUNT_USERS,
};

const ENUM_TO_STRING_MAPPING = Object.fromEntries(Object.entries(STRING_TO_ENUM_MAPPING).map(([k, v]) => [v, k]));

export { TodoId, STRING_TO_ENUM_MAPPING, ENUM_TO_STRING_MAPPING };
